import React, { useEffect, useState } from 'react';

import { useMediaQuery } from '@mui/material';
import router from 'next/router';
import { SiweMessage } from 'siwe';
import { useAccount, useDisconnect, useSignMessage } from 'wagmi';

import { loginAPI } from '@/api/login';
import { sendNotifcation } from '@/utils/notification';
import LogoIcon from 'public/assets/fileverseLogoSad.svg';

import { isTokenValid } from '../../utils';
import NoAccessHeader from '../BodyLayout/NoAccessHeader';
import Wrapper from '../BodyLayout/Wrapper';
import ConnectedUser from '../NoAccessScreen/ConnectedUser';
import DisconnectedUser from '../NoAccessScreen/DisconnectedUser';

const UserRestrictedScreen = ({
  contractAddress,
  tokenName,
  chain,
  gateBalance,
  explorerLink,
}: any) => {
  const isMediaMax1025px = useMediaQuery('(max-width : 1025px)');
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const { data: signer } = useAccount();
  const { signMessageAsync } = useSignMessage();
  const { disconnect } = useDisconnect();
  const [isConnecting, setIsConnecting] = useState(false);
  const handleConnect = async () => {
    try {
      const token = localStorage.getItem('token');
      if (
        !isTokenValid(token, signer?.address) &&
        signer?.address &&
        !isConnecting
      ) {
        setIsConnecting(true);
        const message = new SiweMessage({
          domain: window.location.host,
          address: signer?.address,
          statement: `Welcome to Fileverse\nTimestamp: ${new Date().toISOString()}`,
          uri: window.location.origin,
          version: '1',
        });
        const signature = await signMessageAsync({
          message: message.prepareMessage(),
        });
        const result = await loginAPI({
          address: signer?.address,
          signature,
          message: message.prepareMessage(),
        });
        if (result) {
          const accessToken = result?.data?.token;
          localStorage.setItem('token', accessToken);
          localStorage.setItem('address', signer?.address);
          router.reload();
        }
      }
      setIsConnecting(false);
      return;
    } catch (error) {
      setIsConnecting(false);
      disconnect();
      sendNotifcation('Wallet Disconnected', '', 'danger');
    }
  };
  useEffect(() => {
    handleConnect();
    setIsConnected(
      isTokenValid(localStorage.getItem('token'), signer?.address)
    );
  }, [signer?.address]);

  function getRestrictedComponent(): JSX.Element {
    if (isConnected) return <ConnectedUser tokenName={tokenName} />;
    return <DisconnectedUser tokenName={tokenName} />;
  }

  function restrictedScreenComponent(): JSX.Element {
    return (
      <div className={`w-full ${isConnected ? '' : ' flex items-center px-2'}`}>
        <div
          className={` bg-white m-auto ${
            isMediaMax1025px ? 'p-2' : 'w-[60%] p-4'
          } max-w-[740px] rounded-md overflow-y-auto`}
        >
          <div className={` h-[100%] ${isMediaMax1025px ? '' : 'flex'}`}>
            <div
              className={` ${
                isMediaMax1025px ? '' : 'bg-yellow'
              }  flex items-center justify-center mr-4`}
            >
              <img
                src={LogoIcon.src}
                className={`w-full ${isMediaMax1025px ? 'h-32' : ''}`}
                alt="fileverse"
              />
            </div>
            <div className="w-full items-center flex justify-center">
              {getRestrictedComponent()}
            </div>
          </div>
          <div className="pt-4">
            <p className="font-semibold">Token Details</p>
            <div className="w-full border rounded-md mt-2 p-2">
              <div className="flex">
                <h4 className="w-20">Token :</h4>
                <a href={explorerLink} target="_blank" rel="noreferrer">
                  <p className="w-40 hover:text-gray-400">{tokenName}</p>
                </a>
              </div>
              <div className="flex">
                <h4 className="w-20">Address :</h4>
                <p className=" overflow-x-auto no-scrollbar">
                  {contractAddress}
                </p>
              </div>
              <div className="flex">
                <h4 className="w-20">Chain :</h4>
                <p className="w-40">{chain}</p>
              </div>
              <div className="flex">
                <h4 className="w-20">Amount :</h4>
                <p className="w-40">{gateBalance}</p>
              </div>
            </div>
          </div>
          <footer className="fixed h-[5vh] inset-x-0 bottom-0 border-t border-black flex bg-yellow justify-center">
            <div className="flex text-center p-2 justify-center items-center">
              <strong>
                Attention! Fileverse Solo is a proof of concept on how IPFS can
                work for file sharing. Solo is in alpha. Expect upgrades in 2026
                💛
              </strong>
            </div>
          </footer>
        </div>
      </div>
    );
  }

  return isConnected ? (
    <Wrapper>{restrictedScreenComponent()}</Wrapper>
  ) : (
    <NoAccessHeader>{restrictedScreenComponent()}</NoAccessHeader>
  );
};

export default UserRestrictedScreen;
